/* eslint-disable require-jsdoc */
import React, { Component } from 'react';
import axios from 'axios';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Placeholder from '../../images/placeholder.jpg'

export default class Testimonials extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableData: null
        };
    }


    async componentDidMount() {

        this.getAllCMS('Testimonials');

    }


    async getAllCMS(type) {

        this.setState({ loading: true })
        axios.get(process.env.react_app_base_url + '/api/v1/cms/cms/bytype/' + type)
            .then(res => {
                console.log("Testimonials res", res)

                this.setState({ tableData: res.data.data, loading: false })

            })
            .catch(error => {

                console.log("error.response.status", error)

            });

    }

    render() {
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: true,

            autoplay: true,
            autoplaySpeed: 8000
        };
        return (
            <React.Fragment>
                <div className="container">
                    <div className="testimonials">
                        <h2>Testimonials</h2>
                        <Slider {...settings}>
                            {this.state.tableData === null ? '' : this.state.tableData.reverse().map(item => {
                                return (
                                    <React.Fragment>
                                        <div className="row">
                                            <div className="col-12 col-md-12">
                                                <div className="textWrapper text-left">
                                                    <p className='image'>{item.cms_image == 'undefined' || item.cms_image == null ? <img src={Placeholder} alt="" /> : <img src={process.env.react_app_base_url + "/" + item.cms_image} alt="" />}</p>
                                                    <div dangerouslySetInnerHTML={{ __html: item.cms_description }}></div>
                                                    <h3>{item.cms_course_name}</h3>
                                                    <p>{item.cms_title}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )
                            })
                            }
                        </Slider>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
